<template>
  <div>
    <!-- <div class="prompt">
      <a-carousel :dot-position="dotPosition" :dots="false" :autoplay="true">
      <div>使用提示：1111111111111111111</div>
      <div>2</div>
      <div>3</div>
      <div>4</div>
    </a-carousel>
    </div> -->
    <a-breadcrumb>
      <a-breadcrumb-item>主页</a-breadcrumb-item>
      <a-breadcrumb-item
        ><a @click="() => this.$router.push(path)">{{
          fathertitle
        }}</a></a-breadcrumb-item
      >
      <a-breadcrumb-item v-if="!!childtitle">{{
        childtitle
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <h1 class="title">{{ !!childtitle ? childtitle : fathertitle }}</h1>
  </div>
</template>

<script>
import { getUser } from "@api/userManagement";
export default {
  name: "commentHeader",
  props: {
    fathertitle: {
      type: String,
    },
    childtitle: {
      type: String,
    },
    path: {
      type: String,
    },
  },
  data() {
    return {
      dotPosition: "left",
    };
  },
  mounted() {
    this.getuserinfo();
  },
  methods: {
    getuserinfo() {
      const userId = localStorage.getItem("user_id");
      const that = this;
      getUser(userId).then((r) => {
        if (r.code === -10001) {
          that.$confirm({
            title: "系统提示",
            content: "登录验证过期，请重新登陆",
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
              localStorage.removeItem("ACCESS_TOKEN");
              that.$router.replace("/login");
            },
            onCancel() {
              that.$router.replace("/login");
              localStorage.removeItem("ACCESS_TOKEN");
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-weight: bolder;
  margin: 10px 0 20px 0;
  font-size: 22px;
}
// .prompt{
//   border: 1px solid #ccc;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: 20px;
// }
// /deep/ .ant-carousel .slick-slide {
//   text-align: center;
//   height: 30px;
//   line-height: 30px;
//   overflow: hidden;
// }
</style>